module.exports = __webpack_public_path__ + "static/media/male.39062677.gif";